<template>

  <t-report-generate
      v-model="form"
      modal
      sub-validation-tag="sub-checklist-report-photos-evidence"
      enable-generate-html
      enable-report-by-part
      enable-setting
      url-change-html="checklist/report/view/checklist-evidence/?"
      :add-error-word="onWordDisabledDetail3Photos"
      help="Somente serão consideradas inspeções e ambientes finalizados. Para configurar as informações do cabeçalho utilize o cadastro de empresas."
      origin="Teste de Origem"
      button-title="Relatório"
      :relation-key="form.checklistId"
      java-report
      title="Memorial Fotográfico por Inspeção">

    <template #default="{status,format}">

      <div>

        <b-modal
            v-model="previewModal.visible"
            size="xl"
            centered
            hide-footer
            :title="previewModal.title"
        >
          <div class="report-preview-modal">
            <img :src="previewModal.image" :alt="previewModal.title">
          </div>
        </b-modal>

        <div v-if="!busy">

          <t-input-code-label :command="'insert'" :status="status" required enterprise
                              v-model="form.enterpriseId" @change="getChecklistByEnterprise"/>

          <b-row>

            <b-col cols="6">

              <t-input-search v-if="form.enterpriseId > 0" v-model="form.checklistId"
                              required
                              :options="checklistOptions"
                              @change="getResumeTypeChecklistModel()"
                              placeholder="Todas"
                              label="Inspeção" select/>

              <t-input label="Inspeção" v-else placeholder="Selecione um local" disabled/>

            </b-col>

            <b-col cols="6">

              <t-input-search required select v-model="form.reportLayout"
                              :options="ReportEvidenceLayoutType.list"
                              label="Layout"/>

            </b-col>


          </b-row>





          <section class="report-section">

            <div class="report-section__title">
              Design do Relatório
            </div>

            <b-row>
              <b-col
                  v-for="option in designOptions"
                  :key="option.value"
                  cols="12"
                  md="6"
                  xl="3"
                  class="mb-4"
              >
                <t-report-option-card
                    :option="option"
                    :selected="form.designType === option.value"
                    @select="form.designType = option.value"
                    @preview="openPreview"
                    small
                />
              </b-col>
            </b-row>
          </section>


          <b-row>

            <t-input label="Iniciar númeração"
                     cols="4"
                     help="Utilize por exemplo 6, quando exibir no seu relatório principal outras 5 imagens já existentes"
                     :disabled="!form.subtitleSequenceEnable"
                     v-model="form.subtitleSequenceStart"/>


            <t-input radio required stacked v-model="form.subtitleFormat"
                     cols="4"
                     :options="ReportSubtitleType.list" label="Formato das legendas das fotos"/>


            <t-input v-model="form.environmentSort" required stacked
                     cols="4"
                     :options="ReportEnvironmentSortType.list"
                     radio
                     label="Ordenação das fotos"/>

          </b-row>

          <b-row>
            <b-col cols="4">
              <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideEnvironment" switch>
                Ocultar título do ambiente
                <t-help title="Caso desejar destaque nos nomes de ambientes deixe desmarcado"/>
              </b-form-checkbox>
            </b-col>

            <b-col cols="4">
              <b-form-checkbox class="mt-2 mb-2" v-model="form.subtitleUpperCase" switch>
                Texto da legenda em MAIÚSCULO
                <t-help title="Marque caso desejar converter o texto da legenda maiúscula"/>
              </b-form-checkbox>
            </b-col>

            <!--            <b-col cols="4">
                          <b-form-checkbox class="mt-2 mb-2" v-model="form.reportShowHeader" switch>
                            Cabeçalho 'Relatório Fotográfico' <t-help title="Caso desejar exibir a repetição em cada página com 'Relatório Fotográfico." />
                          </b-form-checkbox>
                        </b-col>-->

            <!--
            <b-col cols="4">
              <b-form-checkbox class="mt-2 mb-2" :disabled="!form.reportShowHeader" v-model="form.reportShowPeriodJob" switch>
                Exibir período do trabalho <t-help title="Caso desejar exibir o período do trabalho no relatório conforme o cadastro do empreendimento deixe marcada essa opção." />
              </b-form-checkbox>
            </b-col>
            -->


          </b-row>


          <!--
          <div class="divider"></div>
          -->


          <!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideSpotFolderDivision" switch>
                  Ocultar Divisão e Pavimento?
                </b-form-checkbox>-->



          <t-msg warning v-if="format === 'docx'">
            <b>Dica</b> <br/>Use a Macro abaixo para melhorar a formatação antes de colar no seu documento final.<br/>
            <ul>
              <li><a href="https://www.youtube.com/watch?v=WqGZXzZh8jA" target="_blank">Video com
                Orientações</a></li>
              <li><a @click="showMacro = !showMacro">Código com Macro para Word</a></li>
            </ul>

            <t-button v-show="showMacro" class="mr-2" small @click="copyToClipboard(macro,'macroVBA')">
              <b-icon-clipboard class="mr-2"></b-icon-clipboard>
              Copiar Macro
            </t-button>

            <t-button v-show="showMacro" small @click="ui.downloadTxt(macro,'macro-vba.txt')">
              <b-icon-download class="mr-2"></b-icon-download>
              Download Macro
            </t-button>

          </t-msg>


          <t-msg info v-if="onWordDisabledDetail3Photos !== ''">
            {{ onWordDisabledDetail3Photos }}
          </t-msg>
        </div>

        <div v-else>
          <t-loading style="min-height: 800px;"/>
        </div>

      </div>

    </template>

    <template #setting>

      <t-msg info v-if="objValid(typeChecklistModel.typeChecklistNumber)">Altere as configurações padrões acessando
        Inspeções > Configurações >
        <b-link :to="{path:'/checklist/type-model/'+typeChecklistModel.typeChecklistNumber}" target="_blank">Modelo da
          Inspeção
          Relacionado
        </b-link>
      </t-msg>

      <b-row>

        <t-input v-model="form.titleReport" cols="6" label="Título do Relatório"
                 small="Podendo ser aplicável ou não conforme o design escolhido"/>

        <t-input label="Rótulo para 'Fotos'" cols="6"
                 help="Altere para algo fora do padrão por exemplo: 'Imagem'"
                 :disabled="!form.subtitleSequenceEnable"
                 v-model="form.sequenceOtherLabel"/>

      </b-row>



      <!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.subtitleSequenceEnable" switch>
              Inserir numeração na legenda?
            </b-form-checkbox>-->

      <!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideHeaderFooter" switch>
              Ocultar todas informações do cabeçalho e rodapé?
            </b-form-checkbox>-->


      <!--      <b-form-checkbox class="mt-2 mb-2" v-show="!form.reportHideSpotFolderDivision" v-model="form.reportBreakPageBySpotFolder" switch>
              Habilitar quebra de página por pavimento?
            </b-form-checkbox>-->

      <t-input-search required radio v-show="!form.reportHideHeaderFooter" v-model="form.reportHeaderPositionLogo"
                      :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>


      <!--      <t-input v-model="form.environmentSort" required stacked
                     :options="ReportEnvironmentSortType.list"
                     radio
                     label="Ordenação dos ambientes"/>-->


      <!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportShowCover" switch>
              Exibir a capa?
            </b-form-checkbox>-->



      <!--
            <t-input v-model="form.subtitleReport" v-show="form.reportShowCover" label="Subtítulo do Relatório"
                     small="Subtitulo padrão de acordo com o título do trabalho selecionado"/>-->


    </template>


  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import checklistService from "@/services/modules/checklist/Checklist.service";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import ReportEvidenceLayoutType from "@/model/types/modules/checklist/ReportEvidenceLayoutType";
import ReportPositionLogoHeaderType from "@/model/types/modules/checklist/ReportPositionLogoHeaderType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import ChecklistService from "@/services/modules/checklist/Checklist.service";
import ReportEnvironmentSortType from "@/model/types/modules/checklist/ReportEnvironmentSortType";
import ReportSubtitleType from "@/model/types/modules/checklist/ReportSubtitleType";
import ReportEvidenceDesignType from "@/model/types/modules/checklist/ReportEvidenceDesignType";
import macroVbaReportEvidence from "@/views/modules/checklist/Report/docs/macro-vba-report-evidence";
import ui from "@/assets/scripts/ui";
import TReportOptionCard from "@/components/template/theme/t-report-option-card.vue";

export default {
  components: {TReportOptionCard},
  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportPhotoChecklistEvidence',
  data() {
    return {
      ui,
      ReportEvidenceLayoutType,
      ReportPositionLogoHeaderType,
      ReportEnvironmentSortType,
      ReportSubtitleType,
      ReportEvidenceDesignType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      busy: false,
      form: {
        enterpriseId: this.enterpriseId,
        checklistId: this.checklistId,
        titleReport: "",
        subtitleReport: "",
        reportHideHeaderFooter: true, /*FIXO POR CONTEXTO*/
        reportHideSpotFolderDivision: true, /*FIXO POR CONTEXTO*/
        reportBreakPageBySpotFolder: false,
        reportLayout: ReportEvidenceLayoutType.type.BASIC_4_PHOTOS_PORTRAIT,
        reportHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        environmentSort: ReportEnvironmentSortType.type.DEFAULT,
        subtitleFormat: ReportSubtitleType.type.BASIC,
        businessEvidenceFileRequiredFields: "",
        businessEvidenceFileLabelOrderFields: "",
        reportHideEnvironment: false,
        reportShowHeader: false,
        reportShowPeriodJob: false,
        subtitleSequenceEnable: true,
        subtitleSequenceStart: 1,
        reportShowCover: false, /*FIXO POR CONTA DO CONTEXTO DESTE RELATÓRIO*/
        designType: ReportEvidenceDesignType.type.DEFAULT,
        sequenceOtherLabel: "Foto",
        subtitleUpperCase: false,
      },
      designOptions: ReportEvidenceDesignType.list,
      checklistOptions: [],
      typeChecklistModel: {},
      showMacro: false,
      macro: macroVbaReportEvidence,
      previewModal: {
        visible: false,
        title: '',
        image: ''
      }
    }
  },
  props: {
    enterpriseId: Number,
    checklistId: Number,
  },
  methods: {

    mountedPrepare() {

      this.busy = true


    },
    async mountedContinued() {

      if (this.enterpriseId > 0) {
        await this.getChecklistByEnterprise()
      }

      if (this.checklistId > 0) {
        await this.getResumeTypeChecklistModel()
      }

      this.busy = false

    },

    openPreview(option) {
      this.previewModal = {
        visible: true,
        title: option.text,
        image: option.preview
      }
    },

    async getChecklistByEnterprise() {

      //Limpa o checklist
      this.form.checklistId = this.checklistId

      let params = new URLSearchParams()
      params.append("enterpriseId", this.form.enterpriseId)
      params.append("status", 1)
      params.append("sorted", "issueDate desc,checklistNumber desc")
      params.append("statusChecklist", StatusChecklistType.type.FINISHED)

      await checklistService.selectList(params).then((list) => {
        this.checklistOptions = list
      }).catch(error => this.responseError(error))



    },

    async getResumeTypeChecklistModel() {

      //Estava apresentando erro toda vez que altera o empreendimento faz reload no modelo de ambiente

      setTimeout(async () => {

        this.busy = true

        if (this.form.checklistId > 0) {

          await ChecklistService.getResume("id", this.form.checklistId).then(async checklistResume => {

            await TypeChecklistModelService.getResume("id", checklistResume.typeChecklistId).then(resume => {

              this.typeChecklistModel = resume

              this.form.titleReport = resume.reportEvidenceDefaultTitle
              this.form.subtitleReport = resume.reportEvidenceDefaultSubtitle

              this.form.businessEvidenceFileRequiredFields = resume.businessEvidenceFileRequiredFields
              this.form.businessEvidenceFileLabelOrderFields = resume.businessEvidenceFileLabelOrderFields

              /*IDEM EM WORK EVIDENCE E CHECKLIST EVIDENCE*/
              this.form.reportLayout = resume.reportEvidenceDefaultLayout
              this.form.reportHeaderPositionLogo = resume.reportEvidenceDefaultHeaderPositionLogo
              /*this.form.reportHideHeaderFooter = resume.reportEvidenceDefaultHideHeaderFooter*/
              /*this.form.reportHideSpotFolderDivision = resume.reportEvidenceDefaultHideSpotFolderDivision*/
              this.form.reportHideEnvironment = resume.reportEvidenceDefaultHideEnvironment
              this.form.reportBreakPageBySpotFolder = resume.reportEvidenceBreakPageBySpotFolder
              /*this.form.reportShowCover = resume.reportEvidenceShowCover*/
              this.form.environmentSort = resume.reportEvidenceDefaultEnvironmentSort
              this.form.subtitleFormat = resume.reportEvidenceDefaultSubtitleFormat

              this.form.designType = resume.reportEvidenceDefaultDesignType
              this.form.sequenceOtherLabel = resume.reportEvidenceDefaultSequenceOtherLabel
              this.form.subtitleUpperCase = resume.reportEvidenceDefaultSubtitleUpperCase

              if(!this.objValid(this.form.sequenceOtherLabel) || this.form.sequenceOtherLabel === ''){
                this.form.sequenceOtherLabel = "Foto"
              }

              /*---*/

            }).catch(error => {
              console.log(error)
              ui.generalResponseError(error)

            })

          }).catch(error => {
            console.log(error)
            ui.generalResponseError(error)

          })


        }

        this.busy = false

      }, 100)

    }


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {

    onWordDisabledDetail3Photos() {
      if (this.form.reportLayout === this.ReportEvidenceLayoutType.type.DETAIL_3_PHOTOS) {
        return 'A geração do relatório em formato Word para este layout 3 fotos detalhada está desabilitada, por favor para este formato utilize PDF.'
      } else {
        return ''
      }

    }
  },

}
</script>
